

import React from 'react'

class SizeContainer extends React.Component {

    render() {

        let optionsList = []

        for (let i = 2; i < 41; i++) {
            optionsList.push(
                <option key={i} value={i}>{i}</option>
            )
        }

        return (
            <span className='reducer-medium-padding-right'>
                {this.props.prompt}
                <select value = { this.props.currentValue } onChange = { this.props.onChangeFunction }>
                    {optionsList}
                </select>
            </span>
        )
    }
}

export default SizeContainer






// WEBPACK FOOTER //
// ./src/scenes/reducer/components/SizeSelector/index.js